module.exports = __webpack_public_path__ + "Server-Disabled.Kubernetes.6535b13e9ea3f5c87eeb410606f2ccdf.hashedasset.svg";